import { ServiceStatus } from '@/features/service-status';
import { Text } from '@/shared/ui/core';
import styles from './header-navigation.module.scss';


export const HeaderNavigation = () => {
    return (
        <div className={ styles.root }>
            <a href="#product">
                <Text
                    weight='medium'
                    className={ styles.label }
                    lineHeight={ 1 }
                >
                    Product
                </Text>
            </a>
            <a href="#pricing">
                <Text
                    weight='medium'
                    className={ styles.label }
                    lineHeight={ 1 }
                >
                    Pricing
                </Text>
            </a>
            <a href="#contact">
                <Text
                    weight='medium'
                    className={ styles.label }
                    lineHeight={ 1 }
                >
                    Contact
                </Text>
            </a>
            <a href="#report">
                <Text
                    weight='medium'
                    className={ styles.label }
                    lineHeight={ 1 }
                >
                    Report Incident
                </Text>
            </a>

            <ServiceStatus className={ styles.label }/>
        </div>
    );
};
